export default __webpack_public_path__ + "static/media/pg-19.bd0490fc.jpg";